import { useDispatch, useSelector } from "react-redux";
import SearchInput from "../../UI/SearchInput";
import { setSearch } from "../../../store/reducers/preguntasConfirmacion/question-confirmation-page/Preguntasconfirmacionplantel.reducer";

const QuestionConfirmationHeaderPlantel = () => {
  const dispatch = useDispatch();
  const searchValue = useSelector(
    (state) => state.preguntasConfirmacionPlantel.search,
  );

  const handleSearchChange = (value) => {
    dispatch(setSearch(value));
  };

  return (
    <div className="mb-3">
      <div className="row g-2 align-items-center">
        {/* título */}
        <div className="col-12 col-md-auto">
          <h5 className="mb-0 fw-semibold text-center text-md-start">
            Preguntas de confirmación
          </h5>
        </div>

        {/* buscador */}
        <div className="col-12 col-md">
          <div className="d-flex flex-column flex-sm-row gap-2 justify-content-md-end">
            <SearchInput
              value={searchValue}
              onChange={handleSearchChange}
              placeholder="Buscar preguntas..."
              minChars={3}
              className="flex-grow-1"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionConfirmationHeaderPlantel;
